/**
 * Under `/public` because `ProtectedRoute` turns away anybody holding no role, and
 * somebody being checked for the first time may hold none. The server still scopes
 * every read to their own clearance. Absolute because wizard steps link out of
 * their own branch.
 */
export const MY_CHILD_PROTECTION_PATH = "/public/my-child-protection";

export const myClearancePath = (clearanceId: string) => `${MY_CHILD_PROTECTION_PATH}/checks/${clearanceId}`;

/** The server refuses asking about anybody else */
export const MY_TRAINING_PATH = `${MY_CHILD_PROTECTION_PATH}/training`;
